import styled from 'styled-components'

export const Label = styled.span`
	display: flex;
	align-items: center;
	column-gap: 6px;
	padding-left: 6px;
`
